import React from 'react';
import ContactContent from '../../components/Content/ContactContent';
import { Wrapper, FormBox } from '../Contact/Contact.styles';

export default function Denunciar() {
  return (
    <Wrapper>
      <FormBox>
        <ContactContent tipo="denuncia" />
      </FormBox>
    </Wrapper>
  );
}
